import React, { PropTypes } from 'react/addons';
import cx from 'classnames';
import $ from 'jquery';
import { Respond, At } from 'react-respond-to';

import moment from 'ofs/moment';
import Icon from 'ofs/components/common/Icon';
import { Calendar } from 'ofs/components/Calendar';
import Modal from 'ofs/components/layers/ModalNext';
import Popover from 'ofs/components/layers/PopoverNext';
import OnMount from 'ofs/utils/OnMount';
import datesAreSame from 'ofs/utils/datesAreSame';
import { gettext } from 'ofs/i18n';

// Return iso format for date if defined
function getISOFormat(date) {
  return date ? moment(date).isoDateFormat() : null;
}

// Return display format for date if defined
function getDisplay(date) {
  return date ? moment(date).longDateFormat() : null;
}

const MESSAGES = {
  ARRIVAL_DATE: gettext('Arrival date'),
  DEPARTURE_DATE: gettext('Departure date'),
  SELECT_DATE: gettext('Select date')
};

const MODAL_DELAY = 200;
const POPUP_DELAY = 150;

const DatePicker = React.createClass({
  propTypes: {
    startValue: PropTypes.instanceOf(Date),
    endValue: PropTypes.instanceOf(Date),

    startFieldName: PropTypes.string,
    endFieldName: PropTypes.string,
    showLabels: PropTypes.bool,

    onChange: PropTypes.func,
    renderDate: PropTypes.func,
    renderCalendarFooter: PropTypes.func,
  },

  getDefaultProps() {
    return {
      showLabels: true,
      startFieldName: 'start_date',
      endFieldName: 'end_date',
      onChange: () => {},
    };
  },

  getInitialState() {
    return {
      startValue: undefined,
      endValue: undefined,

      transitioning: false,

      startSelected: false,
      endSelected: false,
    };
  },

  getStart() {
    return typeof this.state.startValue === 'undefined' ?
      this.props.startValue : this.state.startValue;
  },

  getEnd() {
    return typeof this.state.endValue === 'undefined' ?
      this.props.endValue : this.state.endValue;
  },

  handleStartClick(event) {
    event.preventDefault();
    this.setState({
      'startSelected': true,
    });
  },

  handleEndClick(event) {
    event.preventDefault();

    const start = this.getStart();

    // Open start if not arrival value
    if (!start) {
      this.setState({
        'startSelected': true,
      });
    } else {
      this.setState({
        'endSelected': true,
      });
    }
  },

  handleStartClose(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!$.contains(this.refs.startField.getDOMNode(), event.target)) {
      this.setState({
        'startSelected': false,
        'transitioning': false,
      });
    }
  },

  handleEndClose(event) {
    event.preventDefault();
    event.stopPropagation();

    const { onChange } = this.props;

    if ($.contains(this.refs.endField.getDOMNode(), event.target)) {
      return;
    }

    let start = this.getStart();
    let end = this.getEnd();

    if (!end && start) {
      let momentVal = moment(start);
      momentVal.add(3, 'days');
      end = momentVal.toDate();

      onChange(start, end);
    }

    this.setState({
      'endSelected': false,
      'endValue': end,
      'transitioning': false,
    });
  },

  handleModalClose(event) {
    event.preventDefault();
    event.stopPropagation();

    const { onChange } = this.props;

    let start = this.getStart();
    let end = this.getEnd();

    if (!end && start) {
      let momentVal = moment(start);
      momentVal.add(3, 'days');
      end = momentVal.toDate();

      onChange(start, end);
    }

    this.setState({
      'startSelected': false,
      'endSelected': false,
      'endValue': end,
      'transitioning': false,
    });
  },

  handleStartSelect(selectedDate) {
    const { onChange } = this.props;
    const end = this.getEnd();

    // clear end value if there is no end value or selectedDate is after end
    const openEndPopover = (!end || (end && selectedDate > end));
    const endValue = openEndPopover ? null : end;

    this.setState({
      startValue: selectedDate,
      startSelected: false,
      transitioning: openEndPopover ? true : false,
    }, () => {
      this.setState({
        endValue,
        endSelected: openEndPopover ? true : false,
      });
    });

    if (endValue) {
      onChange(selectedDate, endValue);
    }
  },

  handleEndSelect(selectedDate) {
    const { onChange } = this.props;
    const start = this.getStart();

    this.setState({
      endValue: selectedDate,
      endSelected: false,
      transitioning: false,
    });

    onChange(start, selectedDate);
  },

  // Determine whether date should be selected for the end date picker
  selectedDates(date) {
    const start = this.getStart();
    const end = this.getEnd();

    if (start && datesAreSame(start, date)) {
      return true;
    }

    if (end && datesAreSame(end, date)) {
      return true;
    }
    return false;
  },

  componentWillReceiveProps(nextProps) {
    if (
      !datesAreSame(this.props.startValue, nextProps.startValue) ||
      !datesAreSame(this.props.endValue, nextProps.endValue)
    ) {
      this.replaceState({
        startSelected: false,
        endSelected: false,
      });
    }
  },

  renderCalendarFooter() {
    const { renderCalendarFooter } = this.props;
    if (typeof renderCalendarFooter === 'function') {
      return renderCalendarFooter();
    }

    return null;
  },

  render() {
    const {
      startFieldName,
      endFieldName,
      showLabels,
      renderDate,
    } = this.props;
    const { startSelected, endSelected, transitioning } = this.state;

    const start = this.getStart();
    const end = this.getEnd();

    const inputClasses = cx({
      'ofs-Input': true,
      'ofs-Input--date': true,
      'u-pointer': true,
      'u-no-select': true,
    });

    let initialDate = start ? start : null;
    if (!initialDate && end) {
      initialDate = end;
    }

    const startCalendar = (
      <Calendar
        minimumDate={new Date()}
        weekStarts={1}
        value={start}
        initialDate={initialDate}
        onSelect={this.handleStartSelect}
        isSelected={this.selectedDates}
        renderDate={renderDate}
      />
    );

    const endCalendar = (
      <Calendar
        minimumDate={start ? start : new Date()}
        weekStarts={1}
        value={end}
        onSelect={this.handleEndSelect}
        initialDate={initialDate}
        isSelected={this.selectedDates}
        renderDate={renderDate}
      />
    );

    const modalHeading = (
      <div className="ofs-Modal__Heading">
        <div className="ofs-DatePicker__Header">
          <div className="ofs-DatePicker__HeaderText" style={{ 'opacity': startSelected ? 1 : 0 }}>
            {MESSAGES['ARRIVAL_DATE']}
          </div>
          <div className="ofs-DatePicker__HeaderText" style={{ 'opacity': endSelected ? 1 : 0 }}>
            {MESSAGES['DEPARTURE_DATE']}
          </div>
        </div>
      </div>
    );

    return (
      <div>
        <div className="ofs-Form__Field" ref="startField">
          {showLabels && <label className="ofs-Form__Label" onClick={this.handleStartClick}>{MESSAGES['ARRIVAL_DATE']}</label>}

          <input type="hidden"
            name={startFieldName}
            value={getISOFormat(start)} />

          <div className="ofs-Input__Wrapper" ref="startInput">
            <div className={inputClasses + ' bdd-quicksearch-field-start-date'} onClick={this.handleStartClick}>
              {start ?
                <span className="value">{getDisplay(start)}</span> :
                <span className="ofs-Input__Placeholder">{MESSAGES['SELECT_DATE']}</span>}
            </div>
            <div className="ofs-Input__Icon" onClick={this.handleStartClick}>
              <Icon glyph="calendar" size="small" />
            </div>
          </div>
        </div>

        <OnMount>
          {() => (
            <Respond to="min-width">
              <At value="640px">
                <Popover
                  isOpen={startSelected}
                  closeTimeoutMS={POPUP_DELAY}
                  onRequestClose={this.handleStartClose}
                  attachTo={this.refs.startInput}
                >
                  {startCalendar}
                  {this.renderCalendarFooter()}
                </Popover>
              </At>
            </Respond>
          )}
        </OnMount>

        <div className="ofs-Form__Field" ref="endField">
          {showLabels && <label className="ofs-Form__Label" onClick={this.handleEndClick}>{MESSAGES['DEPARTURE_DATE']}</label>}

          <input type="hidden"
            name={endFieldName}
            value={getISOFormat(end)} />

          <div className="ofs-Input__Wrapper" ref="endInput">
            <div className={inputClasses + ' bdd-quicksearch-field-end-date'} onClick={this.handleEndClick}>
              {end ?
                <span className="value">{getDisplay(end)}</span> :
                <span className="ofs-Input__Placeholder">{MESSAGES['SELECT_DATE']}</span>}
            </div>
            <div className="ofs-Input__Icon" onClick={this.handleEndClick}>
              <Icon glyph="calendar" size="small" />
            </div>
          </div>
        </div>

        <OnMount>
          {() => (
            <Respond to="min-width">
              <At value="640px">
                <Popover
                  isOpen={endSelected}
                  closeTimeoutMS={POPUP_DELAY}
                  onRequestClose={this.handleEndClose}
                  attachTo={this.refs.endInput}
                >
                  {endCalendar}
                  {this.renderCalendarFooter()}
                </Popover>
              </At>
            </Respond>
          )}
        </OnMount>

        <OnMount>
          {() => (
            <Respond to="max-width">
              <At value="639px">
                <Modal
                  isOpen={startSelected || endSelected || transitioning}
                  closeTimeoutMS={MODAL_DELAY}
                  onRequestClose={this.handleModalClose}
                  className="ofs-Modal--centered"
                  modalStyle={{
                    'marginTop': startSelected ? '-25px' : '25px',
                  }}
                >
                  {modalHeading}
                  {startSelected ? startCalendar : endCalendar}
                  {this.renderCalendarFooter()}
                </Modal>
              </At>
            </Respond>
          )}
        </OnMount>
      </div>
    );
  }
});

export default DatePicker;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/DatePickerNext/DatePicker.jsx
 **/